import store from "./global.store";

export * from "./global.store";
export default store;
